/**
 * @generated SignedSource<<e99be6a4a59f815ec26c99e928d445bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type trendOverview_trendFragment$data = {
  readonly CustomerJourney: {
    readonly trend: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly trendData: {
            readonly name: string;
            readonly visible: boolean;
          };
          readonly " $fragmentSpreads": FragmentRefs<"trendCard_trendFragment">;
        };
      } | null> | null;
    };
  };
  readonly " $fragmentType": "trendOverview_trendFragment";
};
export type trendOverview_trendFragment$key = {
  readonly " $data"?: trendOverview_trendFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"trendOverview_trendFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "trendOverview_trendFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CustomerJourneyQueries",
      "kind": "LinkedField",
      "name": "CustomerJourney",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TrendConnection",
          "kind": "LinkedField",
          "name": "trend",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TrendEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Trend",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TrendData",
                      "kind": "LinkedField",
                      "name": "trendData",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "visible",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "trendCard_trendFragment"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "3708325be3b46e558d962c27e6555b28";

export default node;
